import {useIsArticleDetailPage} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';

// This functionality will be removed after 1-2 month since tracking create additional costs
// So to avoid prop drilling and to make the clean-up easy we use this helper hook to be sure that the tracking will be fired on mWeb ADP
export const useTrackMobileAdpFeature = () => {
  const isAdpPage = useIsArticleDetailPage();
  const trackFeature = useTrackFeature();

  return {
    trackMobileAdpFeature:
      isAdpPage && process.env.STACK === 'mobile' ? trackFeature : undefined,
  };
};
